import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const SUITABILITY_HAND_PLANTING = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'FOR - Hand Planting Suitability',
  key: 'Suitability for Hand Planting',
  ruleId: '35',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
